<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="450px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span>Tra cứu thông tin</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <div v-if="errors_exist" class="row">
          <div class="col">
            <v-alert
              dense
              outlined
              type="error"
            >
              {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
              <ul>
                <div v-for="(error, index) in errors">
                  <li :key="index">{{ error[0] }}</li>
                </div>
              </ul>
            </v-alert>
          </div>
        </div>
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="typeSelected"
              :items="types"
              item-text="ten_loai"
              item-value="id"
              label="Loại cơ sở"
              hide-details
              multiple
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="areaSelected"
              :items="areas"
              item-text="name"
              item-value="maqh"
              label="Khu vực"
              hide-details
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="statusSelected"
              :items="status"
              item-text="text"
              item-value="value"
              label="Tình trạng"
              hide-details
              clearable
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary"
          @click="setFilter"
        >
          Xem
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        types: [],
        areas: [],
        typeSelected: null,
        areaSelected: null,
        status: [
          {
            value: '0', 
            text: 'Ngừng hoạt động'
          },
          {
            value: '1', 
            text: 'Đang hoạt động'
          }
        ],
        statusSelected: null,
        filter: {}
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true;
          this.getTypes();
          this.getAreas();
        }
      }
    },
    methods: {
      getTypes () {
        axios.get("api/v1/business-types")
          .then(response => {
            this.types = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getAreas () {
        axios.get("api/v1/get-district-by-province")
          .then(response => {
            this.areas = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      setFilter() {
        this.$emit('confirmed', {
          loai: this.typeSelected,
          khuvuc: this.areaSelected,
          tinhtrang: this.statusSelected
        });
        this.dialog = !this.dialog;
      }
    }
  }
</script>